export default function validateProjectFields(fields) {
  const errors = [];
  if (!fields.name) errors.push('El nombre del proyecto es requerido.');
  if (!fields.location) errors.push('La ubicación del proyecto es requerida.');
  if (fields.gallery.length === 0)
    errors.push('Debes incluir una imágen para el proyecto.');
  return errors;
}
